import React, { useState } from "react";
import { Form, Input, Button, Typography, Row, Col, Divider, notification, Spin } from 'antd';
import Paragraph from "antd/es/skeleton/Paragraph";
import {
    FacebookFilled, InstagramFilled, WhatsAppOutlined, TwitchFilled, TikTokFilled, LinkedinFilled,
    TwitterCircleFilled,
    XFilled,
    XOutlined,
    MailFilled,
    MailOutlined,
    PhoneFilled,
    ClockCircleFilled
} from '@ant-design/icons';

import config from "../config.json"
import axios from "axios";
import Success from "../components/Success";

const { Title } = Typography;

const Contact = () => {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [submitted, setSubmit] = useState(false);
    
    const onFinish = async (values: any) => {
         console.log('Form Values:', values);
        var data= {
            name : values.name,
            phone : values.phone,
            email: values.email,
            message: values.message

        }
        setLoading(true);
        const csrfToken = localStorage.getItem("csrfToken");

        const URL = (config.env === "prod" ? config.prodURL : config.env === "test" ? config.testURL : config.localURL) + "contactmessage";
        console.log("URL: ", URL)
        console.log("Data: ", data)
        try{
            const response = await axios.post(URL , data
            );
            setSuccess(true);
            setSubmit(true);
            console.log("Form submitted successfully:: ", response.data);
        } catch(error){
            notification["error"]({
                message: "Submit Error",
                description: "Something went wrong. Please try again later.",
                placement: 'topRight', // Options: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
              });
              console.error('Error uploading file:', error);
        }
        setLoading(false)

    };
    return (
        <div className="about-container">
            <div className="content">

                <Title className="contact-title">Contact Us</Title>
                <Row justify={'center'}>
                    <Col>
                        <div className="contact-socialmedia" >
                            <h2><ClockCircleFilled /> Business Hours</h2>
                            <p>9:30AM - 5:30PM</p>
                        </div>

                    </Col>
                    <Divider type="vertical" style={{ borderColor: '#7cb305', height: 'auto', margin: 10 }} />
                    <Col>
                        <div className="contact-socialmedia" >
                            <h2 ><PhoneFilled /> Phone</h2>
                            <div >
                                +977 015922895
                            </div>
                            <div >
                                +977 9764399066
                            </div>
                            <div >
                                +977 9764399067
                            </div>
                        </div>

                    </Col>
                    <Divider type="vertical" style={{ borderColor: '#7cb305', height: 'auto', margin: 10 }} />
                    <Col>
                        <div className="contact-socialmedia" >
                            <h2 ><MailOutlined /> Email</h2>

                            <div >
                                brahmajyoti01@gmail.com
                            </div>
                            <div >
                                contactbrahmajyoti@gmail.com
                            </div>

                        </div>

                    </Col>
                    <Divider type="vertical" style={{ borderColor: '#7cb305', height: 'auto', margin: 10 }} />
                    <Col>
                        <div className="contact-socialmedia" >
                            <h2 >Social Media</h2>
                            <div >
                                <a href="https://www.facebook.com/people/Brahma-Jyoti-Holdings/61565656058735/?mibextid=ZbWKwL"><FacebookFilled />Facebook</a>
                            </div>
                            <div >
                                <a href="https://www.instagram.com/brahmagroup04/" ><InstagramFilled /> Instagram </a>
                            </div>
                            <div >
                                <a href="https://wa.me/message/HXXBH2BI6B7GD1"><WhatsAppOutlined /> Whatsapp</a>
                            </div>
                            <div >
                                <a href="https://www.linkedin.com/public-profile/settings?trk=d_flagship3_profile_self_view_public_profile"><LinkedinFilled /> Linkedin</a>
                            </div>
                            <div >
                                <a href="https://x.com/brahmagroup01"><XOutlined /> X</a>
                            </div>
                            <div >
                                <a href="https://www.tiktok.com/@brahmagroup03?is_from_webapp=1&sender_device=pc">  <TikTokFilled /> Tiktok</a>
                            </div>

                            <div>

                            </div>

                        </div>

                    </Col>

                    <Divider type="vertical" style={{ borderColor: '#7cb305', height: 'auto', margin: 10 }} />


                </Row>
                <Row justify={'center'}>
                    <Col>
                    {
                        !submitted ? (
                            <>
                             <h2>Send us a message</h2>
                        <Form
                            name="contact-form"
                            layout="vertical"
                            onFinish={onFinish}
                            className="contact-socialmedia"
                        >
                            {/* Name Field */}
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[
                                    { required: true, message: 'Please enter your name' },
                                    { max: 50, message: 'Name cannot exceed 50 characters' },
                                ]}
                            >
                                <Input placeholder="Enter your name" />
                            </Form.Item>

                            {/* Phone Field */}
                            <Form.Item
                                label="Phone"
                                name="phone"
                                rules={[
                                    { required: false, message: 'Please enter your phone number' },
                                    {
                                        pattern: /^\d{10}$/,
                                        message: 'Please enter a valid 10-digit phone number',
                                    },
                                ]}
                            >
                                <Input placeholder="Enter your phone number" />
                            </Form.Item>
                               {/* Email Field */}
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    { required: true, message: 'Please enter your email' },
                                    {
                                        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                        message: 'Please enter a valid email',
                                    },
                                ]}
                            >
                                <Input placeholder="Enter your email" />
                            </Form.Item>


                            {/* Address Field */}
                            <Form.Item
                                label="Message"
                                name="message"
                                rules={[
                                    { required: true, message: 'Please enter your message' },
                                    { max: 500, message: 'Address cannot exceed 500 characters' },
                                ]}
                            >
                                <Input.TextArea rows={5} cols={50} placeholder="Enter your message" />
                            </Form.Item>

                            {/* Submit Button */}


                            <Row >
                                    <Form.Item style={{ marginRight: '10px' }}>
                                        <Button disabled={loading} type="primary" htmlType="submit">
                                            Submit
                                        </Button>
                                    </Form.Item>
                                    {loading && (
                                        <div className="loading-overlay">
                                            <Spin size="large" /> {/* Ant Design spinner */}
                                        </div>
                                    )}
                                </Row>
                        </Form></>
                        ):
                        (<>
                        <Success/>
                            </>)
                    }
                       


                    </Col>
                    <Divider type="vertical" style={{ borderColor: '#7cb305', height: 'auto', margin: 10 }} />
                    <Col>
                        <h2>Address</h2>
                        <div>
                            <p>Shree Shanti Marga, Koteshwor-32</p>
                            <p>Kathmandu, Nepal</p>
                        </div>
                        <iframe className="iframemap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3533.2876083825!2d85.34167867540131!3d27.67750437619967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19813067d6e3%3A0x35395f60748b1a8d!2sBRAHMA%20JYOTI%20HOLDINGS!5e0!3m2!1sen!2sus!4v1731818679271!5m2!1sen!2sus" loading="lazy"></iframe>
                    </Col>
                </Row>

            </div>

        </div>
    )
}


export default Contact;